// extracted by mini-css-extract-plugin
export default {"first_page":"ServiceMobile_first_page__AkjHJ","end_form":"ServiceMobile_end_form__9KW0C","mobile_service":"ServiceMobile_mobile_service__OHvs0"};